import { render, staticRenderFns } from "./PatientViewer.vue?vue&type=template&id=4b2b7ef5&"
import script from "./PatientViewer.vue?vue&type=script&lang=js&"
export * from "./PatientViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports